import { WebApi } from '../../services/WebApi'

const state = () => ({
  loadingBookingPayment: false,
  bookingPayment: null
})

const mutations = {
  setLoading (state, value) {
    state.loadingBookingPayment = !!value
  },
  setBookingPayment (state, bookingPayment) {
    state.bookingPayment = bookingPayment
  },
  updateBookingPayment (state, updatedBookingPayment) {
    Object.keys(updatedBookingPayment).forEach(key => {
      const newValue = updatedBookingPayment[key]
      if (newValue !== null && newValue !== '' && newValue !== 0) {
        state.bookingPayment[key] = newValue
      }
    })
  }
}

const actions = {
  fetchBookingPaymentAuthenticated ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      commit('setLoading', true)
      WebApi.post('ClientBookingPayment/Authenticated', payload)
        .then(response => {
          commit('setBookingPayment', response.data)
          resolve(response)
        })
        .catch(error => reject(error))
        .finally(() => commit('setLoading', false))
    })
  },
  updateBookingPaymentAuthenticated ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      commit('setLoading', true)
      WebApi.put('ClientBookingPayment/Authenticated', payload)
        .then(response => {
          commit('updateBookingPayment', response.data)
          resolve(response)
        })
        .catch(error => reject(error))
        .finally(() => commit('setLoading', false))
    })
  },
  fetchBookingPaymentAnonymous ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      commit('setLoading', true)
      WebApi.post('ClientBookingPayment/Anonymous', payload)
        .then(response => {
          commit('setBookingPayment', response.data)
          resolve(response)
        })
        .catch(error => reject(error))
        .finally(() => commit('setLoading', false))
    })
  },
  updateBookingPaymentAnonymous ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      commit('setLoading', true)
      WebApi.put('ClientBookingPayment/Anonymous', payload)
        .then(response => {
          commit('updateBookingPayment', response.data)
          resolve(response)
        })
        .catch(error => reject(error))
        .finally(() => commit('setLoading', false))
    })
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
